import React from 'react';
import './aboutUs.css';
import PositionCard from '../positionCard/positionCard';
import Grid from '@material-ui/core/Grid';
import { getAboutContent, getPositions } from '../../services/contentService';
class AboutUs extends React.Component {
    constructor(props) {
      super(props);
            this.state = {
                coverImageUrl: '/content/About/About%20Us/about-us-cover.jpg',
                positions: []
            };
      // To use the 'this' keyword, we need to bind it to our function
    }

        async componentDidMount(){
            try {
                const [about, positions] = await Promise.all([getAboutContent(), getPositions()]);
                this.setState({
                    coverImageUrl: about.coverImageUrl || this.state.coverImageUrl,
                    positions
                });
            } catch (_) {
                this.setState({ positions: [] });
            }
        }

    handleSubmit(){

    }
    render(){ 
        return (
            <div>
            <div>
                <div className='title'>
                About us
            </div>
            <div className='about-cover'>
                <img src={this.state.coverImageUrl} alt='About RAW' />
            </div>
            <div className='description'>
            Robust Architecture Workshop (RAW) is a design practice providing architectural services that impinge on a broader notion of technological and economic robustness.
<br/>
<br/>
From residential and recreational to commercial and institutional, we work on architectural projects of varied programmatic and spatial conditions, developing place-specific solutions to meet the mutual requirements of the client and the user, the place and the environment, and the economy and the industry.
<br/>
<br/>
We are committed to creating a form of architecture that is spatially affable, ecologically sensible, socially affordable, culturally progressive and discursively relevant.
<br/>
<br/>
RAW is also a research-based practice, with a firm dedication to reconciling academic research and building practice within a singular platform.
<br/>
<br/>
Beyond both tactless orientalism and commodified modernity, the anatomy of our practice is built on a technical and cultural 'approach' than on stylistic tropes; an approach that is inherently 'robust' and, therefore, can tolerate economic variables of a project on the one hand, and the complexities of its cultural and technical attributes on the other hand, in order to explore a place-specific and people-centric architecture. 
            </div>
            </div>

             <div className="position-card">
                <div className='title'>
                Positions
            </div>
            <div>
            <Grid container className='gridList' spacing={0.5}>
                        {this.state.positions.map((position)=>(
                            <Grid key={position.key} item className='position-card-grid' xs={6} sm={4} md>
                                <PositionCard position={position}/>
                            </Grid>
                        ))}
            </Grid>
            </div>
            </div>
            </div>

        )
    }

}

export default AboutUs;